var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[_vm.clazz,'icon-' + _vm.name],attrs:{"version":"1.1","width":_vm.w,"height":_vm.h,"viewBox":_vm.box}},_vm._l((_vm.icon.paths),function(path){return _c('path',{attrs:{"d":path.d,"fill":path.fill,"stroke":path.stroke}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2283cbac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue2-svg-icon/Icon.vue
// module id = null
// module chunks = 